export enum BdcFacilityState {
  MISSING = 'MISSING',
  PRESENT = 'PRESENT',
}

export type BdcUpdatePropertyFacility = Pick<BdcPropertyFacility, 'facility_id' | 'state'>
export type BdcUpdateRoomFacility = Pick<BdcRoomFacility, 'room_facility_id' | 'state'>

export interface BdcBaseFacility {
  state: BdcFacilityState
  instances?: {
    instance_id: number
  }[]
}

export interface BdcPropertyFacility extends BdcBaseFacility {
  facility_id: number
}

export interface BdcRoomFacility extends BdcBaseFacility {
  room_facility_id: number
}

export type BdcGetPropertyFacilitiesResponseData = BdcPropertyFacility[]
export type BdcGetRoomFacilitiesResponseData = BdcRoomFacility[]

export type BdcUpdatePropertyFacilitiesPayload = BdcUpdatePropertyFacility[]
export type BdcUpdateRoomFacilitiesPayload = BdcUpdateRoomFacility[]

export enum BdcBathroomType {
  PRIVATE = 'PRIVATE',
  SHARED = 'SHARED',
}

export enum BdcPrivateBathroomType {
  DEFAULT = 'DEFAULT',
  EXTERNAL_BATHROOM = 'EXTERNAL_BATHROOM',
  ATTACHED_BATHROOM = 'ATTACHED_BATHROOM',
}

export enum BdcBathroomLocationType {
  DEFAULT = 'DEFAULT',
  NEXT_DOOR = 'NEXT_DOOR',
  DOWN_THE_HALL = 'DOWN_THE_HALL',
  ACROSS_FROM_THE_ROOM = 'ACROSS_FROM_THE_ROOM',
  IN_THE_LOBBY = 'IN_THE_LOBBY',
  OTHER = 'OTHER',
}

export interface BdcBathroom {
  id?: number
  bathroom_type: BdcBathroomType
  bathroom_location?: string
}

export interface BdcHotelBathroomDetails {
  private_bathroom_state: BdcFacilityState
  shared_bathroom_state: BdcFacilityState
  number_of_bathrooms: number
  private_bathroom_details?: {
    type?: BdcPrivateBathroomType
    location_type?: BdcBathroomLocationType
    location_other?: string
  }
}

export interface BdcBathroomDetails {
  property_bathroom_details?: { bathrooms: BdcBathroom[] }
  hotel_bathroom_details?: BdcHotelBathroomDetails
}

export interface BdcBathroomConfiguration {
  unit_type_id: number
  allowed_options: { bathroom_type: BdcBathroomType; bathroom_locations: string[] }[]
}

export interface BdcFacilityMeta {
  bathroom_configurations: BdcBathroomConfiguration[]
}

export interface BdcPropertyExtendedFacility extends BdcPropertyFacility {
  tokeet_amenity: string
}

export interface BdcRoomExtendedFacility extends BdcRoomFacility {
  tokeet_amenity: string
}

export interface BdcPropertyExtendedFacilityMetadataItem {
  facility_id: number
  facility_name: string
  tokeet_amenity: string
}

export interface BdcRoomExtendedFacilityMetadataItem {
  room_facility_id: string
  room_facility_name: string
  tokeet_amenity: string
}
